<template>
  <div v-if="invoiceToRemove">
    <div id="bg"></div>
    <div id="panel">
      <p>
        <br>
        <panel-invoice-remove-icon-alert />
        <panel-invoice-remove-label-info />
      </p>
      <div id="bottom-panel">
        <div id="buttons">
          <panel-invoice-remove-button :title="'Закрыть'" :click="close" />
          <panel-invoice-remove-button :title="'Отмена'" :click="cancel" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PanelInvoiceRemoveButton from './PanelInvoiceRemoveButton';
  import PanelInvoiceRemoveIconAlert from './PanelInvoiceRemoveIconAlert';
  import PanelInvoiceRemoveLabelInfo from './PanelInvoiceRemoveLabelInfo';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: "removeInvoicePanel",
    components: {
      PanelInvoiceRemoveButton,
      PanelInvoiceRemoveIconAlert,
      PanelInvoiceRemoveLabelInfo,
    },
    computed: {
      ...mapGetters(['invoiceToRemove']),
      playerId() {
        return this.invoiceToRemove.playerId;
      },
    },
    methods: {
      ...mapActions(['setInvoiceToRemove', 'removeInvoice']),
      async close() {
        await this.removeInvoice({ ...this.invoiceToRemove });
      },
      cancel() {
        this.setInvoiceToRemove();
      }
    }
  }
</script>

<style scoped>
  #bg {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: url(../../../../assets/ui-bg_diagonals-thick_8_333333_40x40.png) repeat;
    opacity: 0.5;
  }

  #panel {
    width: 300px;
    height: 128px;
    top: 50%;
    left: 50%;
    margin-left: -150px;
    display: block;
    border-radius: 6px;
    border: 1px solid #dddddd;
    background: #f2f5f7 url(../../../../assets/ui-bg_highlight-hard_100_f2f5f7_1x100.png) 50% top repeat-x;
    color: #362b36;
    font-family: Lucida Grande,Lucida Sans,Arial,sans-serif;
    font-size: 1em;
    position: absolute;
    padding: .2em;
    outline: 0;
    z-index: 100;
  }

  p {
    text-align: center;
    color: #362b36;
    font-family: Lucida Grande,Lucida Sans,Arial,sans-serif;
  }

  #bottom-panel {
    border-top: #dddddd 1px solid;
    margin-top: .5em;
    padding: .3em 1em .5em .4em;
    color: #362b36;
    min-height: 0;
  }

  #buttons {
    margin-right: -10px;
    float: right;
  }
</style>

